import { SearchSidebarProps } from "@made-people/blueprint-search-sidebar";

export const SearchSidebar: SearchSidebarProps = {
  settings: {
    template: "search-suggestions",
    drawerSettings: {
      variants: {
        rounded: {
          initial: "medium",
          lg: "none",
        },
        minHeight: "half-viewport",
        dimmed: "subtle",
        blurred: "none",
        background: "white",
      },
    },
    autoCompletePhrasesSettings: {
      layout: {
        spacing: {
          x: { initial: "sm", md: "lg", lg: "xl" },
          y: {
            initial: "sm",
            md: "sm",
            lg: "sm",
            xl: "sm",
          },
        },
      },
      heading: {
        variants: { headingSize: { initial: "sm", lg: "md" } },
      },
    },
    recentSearchesSettings: {
      isEnabled: true,
      layout: {
        spacing: {
          x: { initial: "sm", md: "lg", lg: "xl" },
          y: {
            initial: "sm",
            md: "sm",
            lg: "sm",
            xl: "sm",
          },
        },
      },
      heading: {
        variants: { headingSize: { initial: "sm", lg: "md" } },
      },
    },
    autoCompleteProductsSettings: {
      layout: {
        spacing: {
          x: { initial: "sm", md: "lg", lg: "xl" },
          y: {
            initial: "sm",
            md: "sm",
            lg: "sm",
            xl: "sm",
          },
        },
      },
      heading: {
        variants: { headingSize: { initial: "sm", lg: "md" } },
      },
    },
    searchInputSettings: {
      layout: {
        spacing: {
          x: { initial: "sm", md: "lg", lg: "xl" },
          y: {
            initial: "md",
            md: "md",
            lg: "md",
            xl: "md",
          },
        },
      },
    },
    linkShortcutsSettings: {
      layout: {
        spacing: {
          x: { initial: "sm", md: "lg", lg: "xl" },
          y: {
            initial: "sm",
            md: "sm",
            lg: "sm",
            xl: "sm",
          },
        },
      },
    },
  },
};
